export default __webpack_public_path__ + "static/media/futropolis.10e071e1.webp";